import { Form } from "formik";
import { PropagateLoader } from "react-spinners";
import Button from "./Button";

const TemplateForm = ({ fields, isSubmitting, textButton="" }) => {
    return (
        <Form className="w-full flex flex-col justify-center items-center gap-5">
            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4">
                {fields}
            </div>
            <Button text={isSubmitting ? <PropagateLoader color="red" /> : textButton} type="submit" bgColor="blue" disabled={isSubmitting}/>
        </Form>
    );
};

export default TemplateForm;